import {apiFetch} from 'lib/fetch'
import type {ListVenue, Venue} from 'types/department'
import {getApiUrl} from '../urls'

export const list = async (): Promise<ListVenue[]> =>
  apiFetch.get<ListVenue[]>(getApiUrl('venues'), {simple: 'true'})

export const show = async (id: number): Promise<Venue> =>
  apiFetch.get<Venue>(getApiUrl('venues', id))
